import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import Providers from "@/app/providers";
import { router } from "@/router";
import "@/lib/telemetry/global-telemetry";
import "@/app/globals.css";

const container = document.getElementById("root");
if (!container) throw new Error("No se encontro el contenedor raiz de la aplicacion");

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
